import styled from"@emotion/styled";import{mediaQuery}from"@wp/src/components/common/grid";const MainContainer=styled.div`
  ${mediaQuery({padding:["8px 8px 16px 8px","12px 12px 16px 12px","16px","20px","20px","24px"]})}
  box-sizing: content-box;
`;export default MainContainer;